(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/product-base/assets/javascripts/product-base.js') >= 0) return;  svs.modules.push('/components/components/product-base/assets/javascripts/product-base.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.ProductBase = function (opt) {
    var el;
    var options;
    var gameColumnElement;
    var contentColumnElement;
    var contentContainerElement;
    var isMarionetteMode = false;
    var isReactMode = false;
    var multiSwiper;
    var self = this;
    var defaultOptions = {
      generalSettings: {
        branding: 'stryktipset'
      },
      useDefaultScroll: {
        isActive: false,
        stickyNav: false
      },
      content: {
        gameColumn: {
          options: {
            grid: {
              xs: 12,
              sm: 6,
              md: 4,
              lg: 4,
              xl: 3
            },
            multiSwiper: {
              nodeId: 'game-column',
              toSubtract: ['#top-content']
            }
          }
        },
        contentColumn: {
          options: {
            grid: {
              xs: 12,
              sm: 6,
              md: 8,
              lg: 8,
              xl: 9
            },
            multiSwiper: {
              nodeId: 'content-column',
              toSubtract: ['#top-content'],
              noScroller: true
            }
          }
        },
        useGameColumnAsTab: false
      },
      tabs: {
        items: [{
          label: 'Överblick',
          active: true,
          anchor: 'overblick'
        }, {
          label: 'Nyheter',
          active: true,
          anchor: 'nyheter'
        }, {
          label: 'Bolagspel',
          active: true,
          anchor: 'bolagspel'
        }, {
          label: 'Kom igång',
          active: true,
          anchor: 'kom-igang'
        }]
      }
    };

    function init() {
      options = $.extend(true, defaultOptions, opt);
      setupMarkup();
      initMultiSwiper();
      attachViews();
    }

    function setupMarkup() {
      var getGridColumnClasses = function getGridColumnClasses(gridOptions) {
        if (svs.core.detect.formfactor.mobile()) {
          return 'col-xs-12';
        }

        return "col-xs-".concat(gridOptions.xs, " col-sm-").concat(gridOptions.sm, " col-md-").concat(gridOptions.md, " col-lg-").concat(gridOptions.lg, " col-xl-").concat(gridOptions.xl);
      };

      if (options.content.useGameColumnAsTab) {
        var game = document.createElement('div');
        game.className = '';
        var tabNav = document.createElement('div');
        tabNav.className = 'js-product-base-tabs-nav product-base-tabs-nav';
        var tabContent = document.createElement('div');
        tabContent.className = 'js-product-base-tabs-content product-base-tabs-content bg-white';
        gameColumnElement = document.createElement('div');
        gameColumnElement.className = "product-base-column-game ".concat(getGridColumnClasses(options.content.gameColumn.options.grid));
        gameColumnElement.id = 'game-column';
        game.appendChild(tabNav);
        game.appendChild(tabContent);
        el = game;
      } else {
        gameColumnElement = document.createElement('div');
        gameColumnElement.className = "product-base-column-game ".concat(getGridColumnClasses(options.content.gameColumn.options.grid));
        gameColumnElement.id = 'game-column';
        contentColumnElement = document.createElement('div');
        contentColumnElement.className = getGridColumnClasses(options.content.contentColumn.options.grid);
        contentColumnElement.id = 'content-column';

        var _tabNav = document.createElement('div');

        _tabNav.className = 'js-product-base-tabs-nav product-base-tabs-nav col-xs-12';

        var _tabContent = document.createElement('div');

        _tabContent.className = 'js-product-base-tabs-content product-base-tabs-content bg-white';
        contentContainerElement = document.createElement('div');
        contentContainerElement.className = 'big-stat-container hide';
        contentContainerElement.id = 'content-container';
        contentColumnElement.appendChild(_tabContent);
        contentColumnElement.appendChild(contentContainerElement);
        var rowElement = document.createElement('div');
        rowElement.className = 'grid-row';
        rowElement.appendChild(_tabNav);
        rowElement.appendChild(gameColumnElement);
        rowElement.appendChild(contentColumnElement);
        el = rowElement;
      }

      options.el = el;
    }

    function attachViews() {
      var isReactView = function isReactView(view) {
        return svs.utils.ns.isNamespace('React.isValidElement') && typeof React.isValidElement === 'function' && React.isValidElement(view) && svs.utils.ns.isNamespace('ReactDOM.render') && typeof ReactDOM.render === 'function';
      };

      var isMarionetteView = function isMarionetteView(view) {
        return svs.utils.ns.isNamespace('Marionette.View') && view instanceof Marionette.View;
      };

      var attachView = function attachView(element, view) {
        if (view) {
          if (isReactView(view)) {
            isReactMode = true;
            ReactDOM.render(view, element);
          } else if (isMarionetteView(view)) {
            isMarionetteMode = true;
            view.render();
            element.appendChild(view.el);
          } else if (typeof view === 'string') {
            element.insertAdjacentHTML('afterbegin', view);
          } else if (_typeof(view) === 'object') {
            element.appendChild(view);
          }
        }
      };

      attachView(gameColumnElement, options.content.gameColumn.view);
      attachView(contentContainerElement, options.content.contentColumn.view);
    }

    function initMultiSwiper() {
      if (!options.content.useGameColumnAsTab) {
        multiSwiper = new svs.components.MultiSwiper({
          scrollerOptions: [options.content.gameColumn.options.multiSwiper, options.content.contentColumn.options.multiSwiper]
        });
        multiSwiper.init();
      }
    }

    function attachedToDOM() {
      var tabs = new svs.components.productBase.Tabs(options, gameColumnElement);
      tabs.on('change', function (index) {
        self.trigger('tabChanged', index, options.tabs[index]);

        if (options.useDefaultScroll) {
          window.scrollTo(0, 0);
        }
      });

      if (options.content.gameColumn.view && typeof options.content.gameColumn.view.triggerMethod === 'function') {
        options.content.gameColumn.view.triggerMethod('attach');
      }

      if (options.content.contentColumn.view && typeof options.content.contentColumn.view.triggerMethod === 'function') {
        options.content.contentColumn.view.triggerMethod('attach');
      }

      if (!options.content.useGameColumnAsTab) {
        multiSwiper.updateSize();
      }
    }

    function dispose() {
      self.el.parentNode.removeChild(self.el);
      self.el = null;
      gameColumnElement = null;
      contentColumnElement = null;
    }

    init();
    self = new svs.core.Events({
      el: el,
      options: options,
      dispose: dispose,
      multiSwiper: multiSwiper,
      attachedToDOM: attachedToDOM
    });
    return function () {
      if (isMarionetteMode) {
        return new svs.components.productBase.Marionette({
          productBase: self
        });
      } else if (isReactMode) {
        return new svs.utils.reactHelpUtils.wrapView(svs.components.ProductBaseMarionette({
          productBase: self
        }));
      }

      return self;
    }();
  };
})(svs);
 })(window);